/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import {
  Container,
  Grid,
  Typography,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  Stack,
  Divider,
} from '@mui/material';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder/lib';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { getOrderData } from '../../../actions';
import { COLOR } from '../../../helpers/colors';
import { breadcrumbNameMap } from '../../../helpers/config';
import { formatAmount } from '../../../helpers/functions';
import OrderDetailsPlaceholder from '../OrderDetailsPlaceholder';
import { styles } from './styles';

const RenderOrderDetails = props => {
  const { orders, t } = props;
  const { selOrderDetailData } = orders;
  const renderTabeView = (
    <>
      {selOrderDetailData.to_OutboundDelivery.results &&
      selOrderDetailData.to_OutboundDelivery.results.length > 0 ? (
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead sx={{ borderTop: `1px solid ${COLOR.borderColor}` }}>
              <TableRow>
                <TableCell align="left" sx={styles.tableHeadCell}>
                  {t('orderScreenTranslations:OUTBOUND_DELIVERY')}
                </TableCell>
                <TableCell align="left" sx={styles.tableHeadCell}>
                  {t('orderScreenTranslations:ITEM')}
                </TableCell>
                <TableCell align="left" sx={styles.tableHeadCell}>
                  {t('orderScreenTranslations:MATERIAL')}
                </TableCell>
                <TableCell align="left" sx={styles.tableHeadCell}>
                  {t('orderScreenTranslations:ACTUAL_DEL_QTY')}
                </TableCell>
                <TableCell align="left" sx={styles.tableHeadCell}>
                  {t('orderScreenTranslations:PICK_QTY')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selOrderDetailData.to_OutboundDelivery.results.map((row, index) => {
                const {
                  PickingQuantity,
                  DeliveryQuantityUnit,
                  ActualDeliveryQuantity,
                  MaterialName,
                  OutboundDeliveryItem,
                  OutboundDelivery,
                } = row;
                return (
                  <TableRow
                    key={index.toString()}
                    sx={{
                      '&:last-child td, &:last-child th': {
                        border: 0,
                      },
                    }}
                  >
                    <TableCell align="left" sx={styles.tableRowCell}>
                      {OutboundDelivery}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableRowCell}>
                      {OutboundDeliveryItem}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableRowCell}>
                      {MaterialName}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableRowCell}>
                      {`${ActualDeliveryQuantity} ${DeliveryQuantityUnit}`}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableRowCell}>
                      {`${PickingQuantity} ${DeliveryQuantityUnit}`}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <>
          <Divider />
          <Typography sx={{ mb: 3, mt: 2, textAlign: 'center', fontWeight: 600, fontSize: 18 }}>
            {t('orderScreenTranslations:NO_DATA_FOUND')}
          </Typography>
        </>
      )}
    </>
  );
  return (
    <Grid>
      <Grid
        sx={{
          border: `1px solid ${COLOR.borderColor}`,
          borderBottomLeftRadius: 5,
          borderBottomRightRadius: 5,
          marginTop: 2,
        }}
      >
        <Grid
          item
          xs={12}
          container
          direction="row"
          justifyContent="space-between"
          sx={{
            background: COLOR.textColor,
            color: COLOR.whiteTextColor,
            p: 3,
            textTransform: 'uppercase',
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
          }}
        >
          <Typography>{`${t('orderScreenTranslations:ORDER_NO')}: ${
            selOrderDetailData.SalesOrder
          }`}</Typography>
          <Typography
            sx={{
              fontSize: 14,
            }}
          >
            {t('orderScreenTranslations:TOTAL_NET_AMT')}:{' '}
            <span style={{ fontWeight: 'bold' }}>
              {formatAmount(
                'en-AE',
                selOrderDetailData.TotalNetAmount,
                selOrderDetailData.TransactionCurrency
              )}
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          container
          direction="row"
          justifyContent="space-between"
          sx={{ paddingY: 2, paddingX: 1, background: COLOR.bgColor }}
        >
          <Grid>
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:OVERALL_STATUS')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selOrderDetailData.OverallSDProcessStatusDesc}
              </span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:REJ_STATUS')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selOrderDetailData.OvrlSDDocumentRejectionStsDesc}
              </span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:DELIVERY_STATUS')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selOrderDetailData.OverallDeliveryStatusDesc}
              </span>
            </Typography>
          </Grid>
          <Grid>
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:CRED_STATUS')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selOrderDetailData.TotalCreditCheckStatusDesc}
              </span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:BLOCK_STATUS')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selOrderDetailData.OverallDelivBlockStatusDesc}
              </span>
            </Typography>

            {selOrderDetailData && selOrderDetailData.OverallDelivBlockStatusDesc === 'Blocked' ? (
              <Typography
                sx={{
                  paddingY: 0.5,
                  paddingX: 1,
                  fontSize: 14,
                }}
              >
                {t('orderScreenTranslations:DEL_BLOCK_REASON')}:{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {selOrderDetailData.DeliveryBlockReason || '-'}
                </span>
              </Typography>
            ) : null}
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:EXP_DATE')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {moment(selOrderDetailData.RequestedDeliveryDate).format('MMMM DD, YYYY') || '-'}
              </span>
            </Typography>
          </Grid>
          <Grid>
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:GROSS_AMT')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {formatAmount(
                  'en-AE',
                  selOrderDetailData.GrossAmount,
                  selOrderDetailData.TransactionCurrency
                )}
              </span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:DISCOUNT_AMT')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {formatAmount(
                  'en-AE',
                  selOrderDetailData.DiscountAmount,
                  selOrderDetailData.TransactionCurrency
                )}
              </span>
            </Typography>

            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:TOTAL_TAX_AMT')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {formatAmount(
                  'en-AE',
                  selOrderDetailData.TotalTaxAmount,
                  selOrderDetailData.TransactionCurrency
                )}
              </span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              {t('orderScreenTranslations:TOTAL_NET_VALUE')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {formatAmount(
                  'en-AE',
                  selOrderDetailData.TotalNetValue,
                  selOrderDetailData.TransactionCurrency
                )}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {selOrderDetailData.to_Item &&
      selOrderDetailData.to_Item.results &&
      selOrderDetailData.to_Item.results.length > 0 ? (
        <>
          <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: 3 }}>
            <Typography sx={{ mb: 1, fontWeight: 600, fontSize: 18 }}>
              {t('orderScreenTranslations:ITEMS')}
            </Typography>
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead sx={{ borderTop: `1px solid ${COLOR.borderColor}` }}>
                  <TableRow>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      {t('orderScreenTranslations:MATERIAL')}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      {t('orderScreenTranslations:DELIVERY_DATE')}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      {t('orderScreenTranslations:REQ_QTY')}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      {t('orderScreenTranslations:STATUS')}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      {t('orderScreenTranslations:NET_VALUE')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selOrderDetailData.to_Item.results.map((row, index) => {
                    const {
                      // Material,
                      Material_Text,
                      TransactionCurrency,
                      NetAmount,
                      CommittedDeliveryDate,
                      RequestedQuantity,
                      SDProcessStatusDesc,
                      SDDocumentRejectionStatusDesc,
                      DeliveryStatusDescription,
                    } = row;
                    return (
                      <TableRow
                        key={index.toString()}
                        sx={{
                          '&:last-child td, &:last-child th': {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell align="left" sx={{ paddingY: 2, paddingX: 1.5 }}>
                          {Material_Text}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {CommittedDeliveryDate
                            ? moment(CommittedDeliveryDate).format('MMMM DD, YYYY')
                            : '-'}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {RequestedQuantity}{' '}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          <Typography sx={styles.tableRowCellStatusText}>
                            {t('orderScreenTranslations:OVERALL_STATUS')}:{' '}
                            <span style={{ fontWeight: 'bold' }}>{SDProcessStatusDesc}</span>
                          </Typography>
                          <Typography sx={styles.tableRowCellStatusText}>
                            {t('orderScreenTranslations:DELIVERY_STATUS')}:{' '}
                            <span style={{ fontWeight: 'bold' }}>
                              {SDDocumentRejectionStatusDesc}
                            </span>
                          </Typography>
                          <Typography sx={styles.tableRowCellStatusText}>
                            {t('orderScreenTranslations:REASON_FOR_REJECTION')}:{' '}
                            <span style={{ fontWeight: 'bold' }}>{DeliveryStatusDescription}</span>
                          </Typography>
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {formatAmount('en-AE', NetAmount, TransactionCurrency)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Divider />
          <Grid item sx={{ mt: 3 }}>
            <Typography sx={{ mb: 1, fontWeight: 600, fontSize: 18 }}>
              {t('orderScreenTranslations:DELIVERY')}
            </Typography>
            {renderTabeView}
          </Grid>
        </>
      ) : null}
    </Grid>
  );
};

class OrderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    try {
      const { orderId } = this.props.match.params;
      this.props.getOrderData(orderId);
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    const { orders, t } = this.props;
    const { orderId } = this.props.match.params;
    const { selOrderDetailData, isOrderDetailLoading } = orders;
    return (
      <Container>
        <Breadcrumbs
          {...this.props}
          data={[
            { name: 'Home', path: '/' },
            { name: 'Orders', path: '/orders' },
            {
              name:
                selOrderDetailData && selOrderDetailData !== null
                  ? selOrderDetailData.SalesOrder
                  : '-',
            },
          ]}
          breadcrumbNameMap={breadcrumbNameMap(t)}
        />

        <ReactPlaceholder
          showLoadingAnimation
          ready={!isOrderDetailLoading}
          customPlaceholder={<OrderDetailsPlaceholder />}
        >
          {selOrderDetailData && selOrderDetailData !== null ? (
            <Box sx={{ marginY: 6 }}>
              <RenderOrderDetails {...this.props} />
            </Box>
          ) : (
            <Box m={5}>
              <Typography variant="h5" textAlign="center">
                {`Unable to Load "${orderId}"`}
              </Typography>
              <Stack flexDirection="row" justifyContent="center">
                <Button
                  variant="text"
                  onClick={() => {
                    this.props.history.push('/orders');
                  }}
                >
                  {t('orderScreenTranslations:GO_BACK_TO_ORDERS')}
                </Button>
              </Stack>
            </Box>
          )}
        </ReactPlaceholder>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    orders: state.orders,
  };
};

const cOrderDetails = connect(mapStateToProps, { getOrderData })(OrderDetails);
const tOrderDetails = withTranslation(['orderScreenTranslations'])(cOrderDetails);

export { tOrderDetails as OrderDetails };
